"use client";

import { usePathname } from "next/navigation";
import { isMarketingPath } from "@/lib/marketing/marketing-paths";

// Step 10.5 commits 1+3+6+10: marketing surfaces use the Tesla
// MarketingNav (rendered per-page) and hide the portal TopBar +
// DeliveryBanner so the fixed transparent-over-hero nav can render
// unobstructed. Authenticated portal-internal routes (/dashboard,
// /admin, /account, /cart, /checkout, /orders) keep the portal
// chrome.
//
// Step 10.5 commit 10 PP3 BUG B fix: /catalog + /catalog/{slug} are
// public marketing surfaces (signed-out + signed-in visitors both
// browse them) and were incorrectly rendering the portal TopBar.
// Moved to MarketingNav alongside / and /about/*. The new /contact
// page joins the marketing chrome set.
//
// DIRECTIVE-040 side-patch Jun 17: /privacy + /terms are public
// legal surfaces — same MarketingNav-only chrome as /about/*.
// Pre-patch they fell through this gate and signed-in visitors
// saw the portal TopBar + DeliveryBanner stacked under
// MarketingNav (dual-nav bug confirmed by Alexis screenshot).
//
// PASTE #214: /faq is a public marketing surface (renders its own
// MarketingNav in app/faq/page.tsx). It was missing here, so the portal
// TopBar stacked on top of MarketingNav — the same dual-nav bug as the
// /privacy + /terms case above.

// EXACT_MARKETING_PATHS + isMarketingPath now live in
// lib/marketing/marketing-paths.ts (single source of truth shared with
// the E-008 guard test). PASTE #229/#230 added /weddings +
// /resources/wedding-flowers + /resources/wedding-calculator there.

// PASTE #246: /pending-approval is a BARE standalone screen for
// non-approved users - it must render NO portal chrome (no TopBar, no
// authenticated nav, no links into the app), only the pending message +
// sign-out. Treat it like a marketing path here so the portal chrome is
// suppressed.
const BARE_PATHS = ["/pending-approval"];

function isBarePath(pathname: string): boolean {
  return BARE_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function PortalChromeGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (isMarketingPath(pathname) || isBarePath(pathname)) return null;
  return <>{children}</>;
}
